import './style.css'
import htmlTemplate from './app.html'
import { Card } from '@local_modules/generic/web-paint/components/index.js'

export default async function ProductionPulse () {
  console.log('start')

  document.body.innerHTML = htmlTemplate
  document.title = 'Production Pulse'

  // Example usage of CardComponent
  // Create a shared observable state object
  const state = {
    counter: 0
  }

  document.getElementById('cards-container').innerHTML = `
    <wp-card id="card1" title="Card 1" content="This is the first card.">X1</wp-card>
    <wp-card id="card2" title="Card 2" content="This is the second card.">C2</wp-card>
  `

  // Get the first card component as a JavaScript object.
  // We use a JSDoc type cast to tell the editor that this HTMLElement is actually an instance of our CardComponent class.
  const card1 = /** @type {Card} */ (document.getElementById('card1'))

  // You can now interact with it like any other JS object.
  // It's an instance of the Card class because 'wp-card' is a registered custom element.
  console.log('Card 1 component as a JS object:', card1)

  // You can access its properties and methods.
  // The 'data' property is set up in the constructor.
  console.log('Card 1 data:', card1?.$data)

  // You can also manipulate it programmatically.
  setTimeout(() => {
    console.log('Updating card 1 title via its JS object')
    card1.$data.title = 'Card 1 (Updated)'
  }, 1000)

  const card3 = new Card({ title: 'Card 3', content: 'This is the third card.', state })
  const card4 = new Card({ title: 'Card 4', content: 'This is the fourth card.', state })

  document.getElementById('cards-container').appendChild(card3)
  document.getElementById('cards-container').appendChild(card4)
  console.log('card3', card3)
  console.log('card3', card3.$data)

  // Listen to events
  card3.addEventListener('ppClicked', function (event) { console.log('event', event); card1.$data.state.counter = state.counter; card1.render() })
  card4.addEventListener('ppClicked', function (event) { console.log('event', event) })

  await new Promise((resolve) => setTimeout(resolve, 500))
  card3.setAttribute('title', 'Updated Card 3 Title')
  await new Promise((resolve) => setTimeout(resolve, 500))
  card3.setAttribute('content', 'Updated content for the third card.')

  await new Promise((resolve) => setTimeout(resolve, 2000))
  card3.$data.counter += 1
  await new Promise((resolve) => setTimeout(resolve, 2000))
  console.log('card3.data.counter', card3.$data.counter)
  console.log('card4.data.counter', card4.$data.counter)

  await fetch('/production-pulse/api/status')
    .then(response => response.json())
    .then(data => {
      console.log('data', data)
    })
    .catch(error => {
      console.error('Error fetching production pulse:', error)
    })

  console.log('end')
}
